
import * as THREE from "three";
import {  useThree } from '@react-three/fiber'
import {  Html } from '@react-three/drei'
import { useGLTF } from '@react-three/drei'
import useMediaQuery from '@material-ui/core/useMediaQuery';
import React, { useRef } from 'react'
import { lerp, lerp3} from '../../Utils';
import {  useFrame } from '@react-three/fiber'
import PhoneNavBar from "./PhoneNavBar";

var url = './3DModels/PhoneDivided/Phone_Divided.gltf';


export default function Phone(props) {

    const { nodes } = useGLTF(url)
    
    const mobile = useMediaQuery('(max-width:960px)');

    const viewport = useThree((state) => state.viewport)

    //scale factor based on camera prospective
    const modelScale = 25;

    //Change the end scale based on the target device
    const endScale = viewport.aspect > 1 ? 0.25 : 0.75;

    const mesh = useRef()
    const div = useRef()

    const mesh1 = useRef()
    const mesh2 = useRef()

    const nav = useRef()

    var time;

    useFrame(() => {
       
 
        time = ( (window.scrollY ) / window.innerHeight)/ 5;

        if(time < 1)
        {
            nav.current.scale.copy(new THREE.Vector3(1,1,1));

            mesh.current.scale.x = lerp(viewport.width/3, endScale * viewport.width/3, time)

            if(mobile)
            {
                div.current.scale.x = lerp(1.0, 0.7 , time)
                div.current.scale.y = lerp(1.0, 0.7 , time)
                div.current.scale.z = lerp(1.0, 0.7 , time)
            } 
            else
            {
                div.current.scale.x = lerp( 1.0, 0.3, time)
                div.current.scale.y = lerp(1.0, 0.3 , time)
                div.current.scale.z = lerp(1.0, 0.3 , time)
            }

            const startX = -viewport.width/modelScale / 2.02;
            const endX = (startX  * endScale) 

            const startX1 = (viewport.width/modelScale / 2) - viewport.width/modelScale / 4 / 2;
            const startY1 = (viewport.height/modelScale / 2) -  viewport.height / modelScale / 10 / 2

            // mesh 1
            mesh1.current.position.copy(lerp3( new THREE.Vector3(startX,0,0.81), new THREE.Vector3(endX,0.0,0.81), time))
            
            //mesh2
            mesh2.current.position.copy(lerp3( new THREE.Vector3(-startX,0,0.81), new THREE.Vector3(-endX,0.0,0.81), time))

            //navbar
            nav.current.position.copy(lerp3( new THREE.Vector3(startX1 - 0.01,startY1,0.81), new THREE.Vector3(0,startY1,0.81), time))

        }
        else
        {
            if( window.scrollY > 8000 )
            {
                nav.current.scale.copy(new THREE.Vector3(0,0,0));
                div.current.scale.copy(new THREE.Vector3(0,0,0));
            }

        }


    })



    //const display = true
    
    /*
    const uniforms = useMemo(
        () =>
          THREE.UniformsUtils.merge([THREE.UniformsLib.lights, tempUniforms]),
        []
    );
    */

    return (
        <>
            <mesh

                position={[0,0,0.81]}
                ref = {mesh}
                geometry={nodes.Phone002.geometry}

            >

                <meshStandardMaterial attach="material" color={props.data.stdMatColor} roughness={props.data.roughness}   metalness={props.data.metalness} />


            </mesh>

            <mesh

                ref = {mesh1}
                geometry={nodes.Left_Phone001.geometry}

            >

                <meshStandardMaterial attach="material" color={props.data.stdMatColor} roughness={props.data.roughness}   metalness={props.data.metalness} />



            </mesh>

            <mesh

                ref = {mesh2}
                geometry={nodes.Right_Phone001.geometry}

            >

                 <meshStandardMaterial attach="material" color={props.data.stdMatColor} roughness={props.data.roughness}   metalness={props.data.metalness} />


            </mesh>

            <mesh

                ref = {nav}

            >

                <Html

                    center   
                    transform
                    zIndexRange={[100, 0]}
                    distanceFactor={0.125} 
                        
                    style={{

                        transition: 'all 2.5s',
                        opacity: 1,

                    }}

                >
                    <PhoneNavBar></PhoneNavBar>

                </Html>

            </mesh>

            <mesh

                {...props}
                ref = {div}
                position={[0,0,0.81]}
               

            >
                <Html
                        
                    center   
                    transform
                    zIndexRange={[100, 0]}
                     distanceFactor={0.0775} 
              

                >
                    <div 
                        
                        style={{
                            textAlign: `center`,
                            color: `whitesmoke`,
                            fontSize:mobile ? '70px': '220px',
                            fontFamily:'sofia-pro',

                        }}

                    >
                        Från ide till  <br />
                        verklighet 
                    </div>
                     
                </Html>

            </mesh>

            <mesh

                {...props}
                scale = { [1,1,1] }
                position={[0,0,-1]}

            >
                <Html
                        
                    center   
                    transform
                    zIndexRange={[100, 0]}
                    opacity = {0}

                >
                    <div 
                        
                        style={{
                            textAlign: `center`,
                            fontSize: `1px`,

                        }}

                    >
                        .
                    
                    </div>

                </Html>

            </mesh>

        </>
  );
}

useGLTF.preload(url)
